<div class="psychometric-test-container px-3 w-full">
  <!-- Debug Info -->
  <!-- <div *ngIf="true" class="p-3 bg-yellow-100 mb-3">
    <strong>Debug:</strong> Loading: {{ loading }}, Status: {{ userTestStatus }}, Polling: {{ justPaidPolling }}
  </div> -->

  <!-- Post-payment confirmation polling indicator -->
  <div *ngIf="justPaidPolling" class="container_width w-full flex flex-column align-items-center justify-content-center gap-4"
    style="min-height: 44vh;">
    <p-progressSpinner></p-progressSpinner>
    <p style="font-size: 1.1rem; font-weight: 500;">Confirming your payment, please wait…</p>
  </div>

  <div *ngIf="loading && !justPaidPolling" class="container_width w-full flex flex-column align-items-center justify-content-center gap-4"
    style="min-height: 44vh;">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="!loading && !justPaidPolling" [ngSwitch]="userTestStatus">

    <div *ngSwitchCase="UserTestStatus.TestSelection">
      <div class="pt-landing w-full">

        <!-- ===================== HERO ===================== -->
        <section class="pt-hero">
          <div class="pt-hero__inner">
            <div class="pt-hero__content">
              <span class="pt-badge pt-badge--light">+ Psychometric Test</span>
              <h1 class="pt-hero__title">
                Stop guessing.<br />
                Know your career<br />
                before Class 12 ends
              </h1>
              <p class="pt-hero__subtitle">
                India's most accurate Psychometric Test gives you a personalised career roadmap — built on
                science, not guesswork. 15 minutes. Life-changing clarity.
              </p>
              <div class="pt-hero__actions">
                <p-button label="Take the Test" icon="pi pi-send" styleClass="pt-btn pt-btn--primary"
                  [loading]="mindlerTestRequestLoading()" (click)="scrollToId('pt-assessment')"></p-button>
                <p-button label="See Sample Report" styleClass="pt-btn pt-btn--ghost"
                  (click)="scrollToId('pt-discover')"></p-button>
              </div>
              <div class="pt-hero__stats">
                <div class="pt-hero__stat">
                  <span class="pt-hero__stat-num">2.7M+</span>
                  <span class="pt-hero__stat-label">Students tested</span>
                </div>
                <div class="pt-hero__stat">
                  <span class="pt-hero__stat-num">97%</span>
                  <span class="pt-hero__stat-label">Accuracy rate</span>
                </div>
                <div class="pt-hero__stat">
                  <span class="pt-hero__stat-num">36-page</span>
                  <span class="pt-hero__stat-label">Career report</span>
                </div>
              </div>
            </div>
            <div class="pt-hero__visual">
              <img src="../../../assets/images/brain.png" alt="" class="pt-hero__brain-img">
            </div>
          </div>

          <!-- yellow feature strip -->
          <div class="pt-strip">
            <div class="pt-strip__item"><i class="pi pi-check-circle"></i> Science-backed methodology</div>
            <div class="pt-strip__item"><i class="pi pi-clock"></i> Takes only 15 minutes</div>
            <div class="pt-strip__item"><i class="pi pi-shield"></i> Trusted by top school counsellors</div>
            <div class="pt-strip__item"><i class="pi pi-users"></i> 1-on-1 expert counselling included</div>
          </div>
        </section>

        <!-- ===================== WHAT YOU DISCOVER ===================== -->
        <section id="pt-discover" class="pt-section">
          <div class="pt-section__head">
            <span class="pt-badge">What you discover</span>
            <h2 class="pt-section__title">Four things you'll know<br />about yourself after the test</h2>
            <p class="pt-section__sub">Most students pick careers based on marks or peer pressure. The Psychometric
              Test shows you what actually fits you.</p>
          </div>
          <div class="pt-grid pt-grid--4">
            <div class="pt-discover-card">
              <div class="pt-discover-card__icon"><img src="../../../assets/icons/best_fit.svg" alt=""></div>
              <h4>Identify Your Skills &amp; Interests</h4>
              <p>Find out what truly interests you and which career fields are closest to your natural skills.</p>
            </div>
            <div class="pt-discover-card">
              <div class="pt-discover-card__icon"><img src="../../../assets/icons/data_driven.svg" alt=""></div>
              <h4>Understand Your Personality</h4>
              <p>Discover your strengths &amp; weaknesses, likes &amp; dislikes and get a clear picture of your
                behaviour type.</p>
            </div>
            <div class="pt-discover-card">
              <div class="pt-discover-card__icon"><img src="../../../assets/icons/bluprint.svg" alt=""></div>
              <h4>Find Your True Potential</h4>
              <p>Understand what you are genuinely good at — beyond marks — and discover your hidden potential.</p>
            </div>
            <div class="pt-discover-card">
              <div class="pt-discover-card__icon"><img src="../../../assets/icons/target.png" alt=""></div>
              <h4>Make Smarter Career Choices</h4>
              <p>Get your top personalised report — no more "what should I do after 12th?"</p>
            </div>
          </div>
        </section>

        <!-- ===================== WHICH ASSESSMENT (ACTION BUTTONS) ===================== -->
        <section id="pt-assessment" class="pt-section pt-section--muted">
          <div class="pt-section__head">
            <span class="pt-badge">Choose your career test</span>
            <h2 class="pt-section__title pt-section__title--blue">Which assessment is right for you?</h2>
            <p class="pt-section__sub">Both are built on the same scientifically validated framework — pick the one
              that matches where you are in school.</p>
          </div>
          <div class="pt-grid pt-grid--2">
            <!-- Stream -->
            <div class="pt-assess-card">
              <div class="pt-assess-card__top">
                <div class="pt-assess-card__icon"><img src="../../../assets/icons/best_fit.svg" alt=""></div>
                <span class="pt-tag pt-tag--yellow">Grade 9 – 10</span>
              </div>
              <h3>Stream Assessment</h3>
              <p class="pt-assess-card__desc">Find the right stream — Science, Commerce or Humanities — based on how you
                naturally think and work, before you have to pick your 11th grade subjects.</p>
              <ul class="pt-check-list">
                <li><img src="../../../assets/icons/green-check.svg" alt=""><span>4-dimension framework, purpose-built
                    for 9th &amp; 10th graders</span></li>
                <li><img src="../../../assets/icons/green-check.svg" alt=""><span>Trait-by-trait breakdown with a
                    personal development plan</span></li>
                <li><img src="../../../assets/icons/green-check.svg" alt=""><span>Detailed stream matches — subjects,
                    degrees &amp; career doors it opens</span></li>
              </ul>
              <p-button label="Take the Stream Test" icon="pi pi-send" styleClass="pt-btn pt-btn--primary pt-btn--block"
                [loading]="mindlerTestRequestLoading()" (click)="requestTest(1)"></p-button>
            </div>
            <!-- Career -->
            <div class="pt-assess-card">
              <div class="pt-assess-card__top">
                <div class="pt-assess-card__icon"><img src="../../../assets/icons/data_driven.svg" alt=""></div>
                <span class="pt-tag pt-tag--blue">Grade 11 – 12+</span>
              </div>
              <h3>Career Assessment</h3>
              <p class="pt-assess-card__desc">Go deeper into your best-fit career with our most comprehensive framework
                including how you handle emotions and people, not just what you're good at.</p>
              <ul class="pt-check-list">
                <li><img src="../../../assets/icons/green-check.svg" alt=""><span>5-dimension framework across 56
                    sub-dimensions</span></li>
                <li><img src="../../../assets/icons/green-check.svg" alt=""><span>Emotional Quotient scoring: empathy,
                    conflict management &amp; more</span></li>
                <li><img src="../../../assets/icons/green-check.svg" alt=""><span>5 ranked career matches with degree
                    paths &amp; top recruiters</span></li>
              </ul>
              <p-button label="Take the Career Test" icon="pi pi-send" styleClass="pt-btn pt-btn--primary pt-btn--block"
                [loading]="mindlerTestRequestLoading()" (click)="requestTest(2)"></p-button>
            </div>
          </div>
        </section>

        <!-- ===================== HOW IT WORKS ===================== -->
        <section class="pt-section">
          <div class="pt-section__head">
            <span class="pt-badge">How it works</span>
            <h2 class="pt-section__title pt-section__title--blue">Three steps to your career clarity</h2>
            <p class="pt-section__sub">It's simpler than your last MCQ test — and far more rewarding.</p>
          </div>
          <div class="pt-grid pt-grid--3">
            <div class="pt-step-card">
              <span class="pt-step-card__num">01</span>
              <h4>Answer Honestly, Not Strategically</h4>
              <p>~60 questions about your personality, preferences, activities and subjects. No right or wrong answers.
                Takes 12-15 minutes.</p>
              <span class="pt-pill">12-15 min</span>
            </div>
            <div class="pt-step-card">
              <span class="pt-step-card__num">02</span>
              <h4>AI Matches You to Top Careers</h4>
              <p>Our algorithm cross-references your responses with 56 evaluation parameters to find your best career
                matches from 500+ careers.</p>
              <span class="pt-pill">56 parameters</span>
            </div>
            <div class="pt-step-card">
              <span class="pt-step-card__num">03</span>
              <h4>Get Your 36 Page Career Report</h4>
              <p>Receive a detailed career blueprint with your personality profile, top career matches, recommended
                streams and action plan.</p>
              <span class="pt-pill">36 page report</span>
            </div>
          </div>
        </section>

        <!-- ===================== WHY TAKE IT (DARK) ===================== -->
        <section class="pt-why">
          <div class="pt-why__media">
            <div class="pt-why__reel-wrap">
  <video
    controls
    autoplay
    muted
    playsinline
    loop
    poster="../../../assets/images/reel-thumbnail.jpg"
    style="width:100%; height:100%; min-height:480px; border-radius:12px; display:block; object-fit:cover;">
    <source [src]="videoUrl" type="video/mp4">
  </video>
</div>
<!-- </div> -->
          </div>
          <div class="pt-why__content">
            <span class="pt-badge pt-badge--light">Why this matters</span>
            <h2 class="pt-why__title">Why take a<br />Psychometric Test?</h2>
            <p class="pt-why__lead">Because every year, thousands of students pick the wrong stream — and realise it too
              late. This test knows better and saves years of regret.</p>
            <ul class="pt-why__list">
              <li>
                <span class="pt-why__dot"><i class="pi pi-bolt"></i></span>
                <span><b>Identifies your real skills &amp; strengths</b><br />Not what your marks say — what you're
                  actually built for.</span>
              </li>
              <li>
                <span class="pt-why__dot"><i class="pi pi-chart-bar"></i></span>
                <span><b>Analyses personality, aptitude &amp; learning style</b><br />Know how you think, not just what
                  you know.</span>
              </li>
              <li>
                <span class="pt-why__dot"><i class="pi pi-forward"></i></span>
                <span><b>Enables smarter, faster career planning</b><br />Stop spending years confused. Get clarity in
                  15 minutes.</span>
              </li>
              <li>
                <span class="pt-why__dot"><i class="pi pi-user"></i></span>
                <span><b>Helps you understand yourself better</b><br />Self-awareness is the #1 predictor of long-term
                  career success.</span>
              </li>
            </ul>
          </div>
        </section>

        <!-- ===================== STATS BAR ===================== -->
        <section class="pt-statsbar">
          <div class="pt-statsbar__item">
            <span class="pt-statsbar__num">2.4L+</span>
            <span class="pt-statsbar__label">Students have taken the test</span>
          </div>
          <div class="pt-statsbar__item">
            <span class="pt-statsbar__num">500+</span>
            <span class="pt-statsbar__label">Career paths mapped</span>
          </div>
          <div class="pt-statsbar__item">
            <span class="pt-statsbar__num">56</span>
            <span class="pt-statsbar__label">Evaluation parameters</span>
          </div>
          <div class="pt-statsbar__item">
            <span class="pt-statsbar__num">97%</span>
            <span class="pt-statsbar__label">Student satisfaction rate</span>
          </div>
        </section>

        <!-- ===================== TESTIMONIALS ===================== -->
        <section class="pt-section">
          <div class="pt-section__head">
            <span class="pt-badge">Student stories</span>
            <h2 class="pt-section__title pt-section__title--blue">What students say after taking the test</h2>
            <p class="pt-section__sub">Real students, real clarity. From Class 11 confusion to confident career
              decisions.</p>
          </div>
          <div class="pt-grid pt-grid--3">
            <div class="pt-quote-card">
              <div class="pt-stars"><i class="pi pi-star-fill"></i><i class="pi pi-star-fill"></i><i
                  class="pi pi-star-fill"></i><i class="pi pi-star-fill"></i><i class="pi pi-star-fill"></i></div>
              <p>"I was between PCM and Commerce. After the test I finally understood why I was always more interested
                in business than formulas. Now I'm in BBA and loving it."</p>
              <div class="pt-quote-card__author">
                <span class="pt-avatar">RS</span>
                <div><b>Riya Sharma</b><small>Class 12 · BBA, Delhi University</small></div>
              </div>
            </div>
            <div class="pt-quote-card">
              <div class="pt-stars"><i class="pi pi-star-fill"></i><i class="pi pi-star-fill"></i><i
                  class="pi pi-star-fill"></i><i class="pi pi-star-fill"></i><i class="pi pi-star-fill"></i></div>
              <p>"Everyone told me to do Engineering. The report showed I'm more suited for design thinking and creative
                problem-solving. I took Architecture. Best decision ever."</p>
              <div class="pt-quote-card__author">
                <span class="pt-avatar">AK</span>
                <div><b>Arjun Kapoor</b><small>Class 12 · B.Arch, SPA Delhi</small></div>
              </div>
            </div>
            <div class="pt-quote-card">
              <div class="pt-stars"><i class="pi pi-star-fill"></i><i class="pi pi-star-fill"></i><i
                  class="pi pi-star-fill"></i><i class="pi pi-star-fill"></i><i class="pi pi-star-fill"></i></div>
              <p>"My parents wanted me in medicine. My report showed a strong aptitude for law and social sciences. Now
                I'm in NLSIU and genuinely passionate about what I study."</p>
              <div class="pt-quote-card__author">
                <span class="pt-avatar">PM</span>
                <div><b>Priya Mehta</b><small>Class 12 · Law, Bangalore</small></div>
              </div>
            </div>
          </div>
        </section>

        <!-- ===================== FAQ ===================== -->
        <section class="pt-section pt-section--muted">
          <div class="pt-section__head">
            <h2 class="pt-section__title pt-section__title--blue">FAQs</h2>
          </div>
          <div class="pt-faq">
            <div class="pt-faq__item" *ngFor="let faq of faqs; let i = index" [class.pt-faq__item--open]="openFaqIndex === i">
              <button type="button" class="pt-faq__q" (click)="toggleFaq(i)">
                <span>{{ faq.question }}</span>
                <i class="pi" [ngClass]="openFaqIndex === i ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
              </button>
              <div class="pt-faq__a" *ngIf="openFaqIndex === i">
                <p>{{ faq.answer }}</p>
              </div>
            </div>
          </div>
        </section>

        <!-- ===================== FINAL CTA ===================== -->
        <section class="pt-final">
          <h2>Don't let Class 12 pass<br />without knowing your answer.</h2>
          <p>2.7 Millions + students already have their career clarity. It takes 15 minutes. There's no reason to wait.
          </p>
          <p-button label="Get Started" icon="pi pi-send" styleClass="pt-btn pt-btn--primary"
            [loading]="mindlerTestRequestLoading()" (click)="scrollToId('pt-assessment')"></p-button>
        </section>

      </div>
    </div>

    <div *ngSwitchCase="UserTestStatus.RequestPending">
      <div class="mb-3 px-3">
        <p-button icon="pi pi-arrow-left" label="Back to Test Selection" [text]="true" (click)="userTestStatus = UserTestStatus.TestSelection"></p-button>
      </div>
      <app-billing [orderSummary]="orderSummary">
      </app-billing>
    </div>

    <div *ngSwitchCase="UserTestStatus.RequestRejected">
      <div class="w-full flex flex-column gap-4">
        <h3 class="text-left font-bold text-3xl">Request Rejected</h3>
        <p class="text-left font-normal text-base">Your request has been rejected. Please try again later.</p>
      </div>
    </div>

    <div *ngSwitchCase="UserTestStatus.NotStarted">
      <app-payment-confirmation [paymentConfirmation]="paymentConfirmation" (testLaunch)="startTest()">
      </app-payment-confirmation>
    </div>

    <div *ngSwitchCase="UserTestStatus.Started || UserTestStatus.Pending">
      <div class="iframe-container w-full">
        <iframe [src]="testUrl" width="100%" height="600" frameborder="0"
          sandbox="allow-scripts allow-same-origin allow-forms" title="Psychometric Test"
          style="border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"></iframe>
      </div>
    </div>

    <div *ngSwitchCase="UserTestStatus.Completed">
      <div class="pt-result">
        <button type="button" class="pt-result__back" (click)="backToDashboard()">
          <i class="pi pi-arrow-left"></i> Back to Dashboard
        </button>

        <div class="pt-result__head">
          <div class="pt-result__trophy"><i class="pi pi-trophy"></i></div>
          <span class="pt-result__eyebrow">&#10022; Assessment Complete &#10022;</span>
          <h1 class="pt-result__title">
            Your Top {{ matchLabel }} <span class="pt-result__title-accent">Matches</span>
          </h1>
        </div>

        <div class="pt-result__list">
          <div *ngFor="let stream of streams; trackBy: trackByStreamId; let i = index"
            class="pt-match" [class.pt-match--best]="i === 0">
            <span class="pt-match__rank">{{ i + 1 }}</span>
            <span class="pt-match__name">{{ stream.name }}</span>
            <span class="pt-match__tag" *ngIf="i === 0">&#10022; Best Match</span>
          </div>
        </div>

        <div class="pt-result__actions">
          <p-button label="Download Summary Report" icon="pi pi-download" styleClass="pt-btn pt-btn--accent"
            *ngIf="summaryReportUrl" (click)="openUrl(summaryReportUrl)"></p-button>
          <button type="button" class="pt-link" *ngIf="detailReportUrl" (click)="openUrl(detailReportUrl)">
            Download Detail Report <i class="pi pi-arrow-right"></i>
          </button>
          <button type="button" class="pt-link" (click)="openAnalysisDialog()">
            Schedule Analysis with a Mentor <i class="pi pi-arrow-up-right"></i>
          </button>
        </div>
      </div>

      <p-dialog header=" Schedule analysis with  mentor " [(visible)]="showAnalysisDialog" [modal]="true"
        [style]="{width: '50vw'}" [breakpoints]="{'960px': '75vw', '640px': '90vw'}">
        <div class="flex flex-column gap-3 pt-3">
          <span class="p-text-secondary">Please put in your and your parents availibility for the one on one analysis
            session. Also mention any specific quesitons you might have.</span>

          <textarea pInputTextarea [(ngModel)]="analysisMessage" rows="5" class="w-full"
            placeholder="Type your requirements here..."></textarea>
        </div>

        <ng-template pTemplate="footer">
          <p-button label="Cancel" icon="pi pi-times" (click)="showAnalysisDialog = false"
            styleClass="cancel_AnalysisRequest"></p-button>
          <p-button label="Submit Request" icon="pi pi-check" styleClass="submit_AnalysisRequest"
            (click)="submitAnalysisRequest()" [loading]="analysisLoading" autofocus></p-button>
        </ng-template>
      </p-dialog>

    </div>

  </div>
</div>